import { ThreeSixty } from '@mui/icons-material';
import { Button, type ButtonProps, Typography } from '@mui/material';
import { useCourses } from '@/providers';
import { useViewStore } from '@/stores';

export default function ButtonStartNewTestRun({ size = 'medium' }: { size?: ButtonProps['size'] }) {
  const { courseStatus } = useCourses();
  const { toggleDialog } = useViewStore();

  const onStartNewTestRun = (): void => {
    if (!courseStatus?.repetitions) throw new Error('Repetitions not found');
    const { remaining } = courseStatus.repetitions;
    const remainingAfterSubmission = remaining - 1;
    const content = (
      <Typography>
        Du kannst den Vorgang nicht rückgängig machen. Im Anschluss verbleiben Dir{' '}
        {remainingAfterSubmission === 0
          ? 'keine weiteren Testruns.'
          : `noch ${remainingAfterSubmission} weitere Testruns.`}{' '}
        Du kannst weitere Testruns erwerben.
      </Typography>
    );
    toggleDialog({
      action: 'renewTest',
      actionLabel: 'Neuen Testrun beginnen',
      content,
      title: 'Möchtest Du einen neuen Testrun starten?',
    });
  };

  return (
    <Button variant="contained" startIcon={<ThreeSixty />} onClick={onStartNewTestRun} size={size}>
      Neuer Testrun
    </Button>
  );
}
